<template>
  <Teleport to="body">
    <div v-if="isVisible" class="fixed inset-0 z-50">
      <div class="absolute inset-0 bg-dark/60" />

      <div class="absolute bottom-0 left-0 right-0">
        <div
          class="w-full border border-line bg-white pb-[max(env(safe-area-inset-bottom),16px)] pt-16 shadow-2xl md:gap-20 md:pt-20"
          role="dialog"
          aria-live="polite"
          :aria-label="$t('cookieConsent.ariaLabel')"
        >
          <JContainer>
            <div
              class="flex flex-col gap-12 md:flex-row md:items-center md:justify-between"
            >
              <div
                class="flex min-w-0 flex-1 items-center gap-12 md:gap-16 md:pr-16"
              >
                <div
                  class="flex h-40 w-40 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary"
                  aria-hidden="true"
                >
                  <JIcon name="cookie" />
                </div>

                <div class="min-w-0">
                  <p class="text-sm font-semibold text-dark md:text-base">
                    {{ $t('cookieConsent.title') }}
                  </p>
                  <p class="text-sm text-gray-600 md:text-base">
                    {{ $t('cookieConsent.description') }}
                  </p>
                </div>
              </div>

              <div
                class="flex shrink-0 flex-col gap-8 sm:flex-row sm:flex-wrap sm:justify-end"
              >
                <JButton
                  class="shrink-0 whitespace-nowrap"
                  size="md"
                  @click="accept"
                >
                  {{ $t('words.accept') }}
                </JButton>

                <JButton
                  class="shrink-0 whitespace-nowrap"
                  size="md"
                  variant="tonal"
                  color="secondary"
                  @click="reject"
                >
                  {{ $t('words.reject') }}
                </JButton>

                <JButton
                  class="shrink-0 whitespace-nowrap"
                  size="md"
                  variant="tonal"
                  color="secondary"
                  @click="openSettings"
                >
                  {{ $t('cookieConsent.actions.settings') }}
                </JButton>
              </div>
            </div>
          </JContainer>
        </div>
      </div>

      <!-- <JModal v-model="settingsOpen" size="sm" center>
        <div class="p-16">
          <h6 class="text-dark">Cookie settings</h6>
          <p class="mt-8 text-gray-600">
            Review our cookie policy to learn more about how we use cookies.
          </p>

          <div class="mt-16 flex flex-col gap-8 sm:flex-row sm:justify-end">
            <JButton size="md" variant="outlined" color="primary" class="rounded-md" @click="settingsOpen = false">
              Close
            </JButton>

            <JButton size="md" class="rounded-md" @click="goToCookiePolicy">
              View cookie policy
            </JButton>
          </div>
        </div>
      </JModal> -->
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useCookies } from '@vueuse/integrations/useCookies'
import { JButton, JContainer, JIcon } from '@journey/ui-kit'
import { COOKIE_EXPIRATION_TIME, COOKIE_NAME } from './CookieConsent.constants'
import type { CookieConsentValue } from './CookieConsent.types'
import featureFlag from '@/config/featureFlag'

const settingsOpen = ref(false)

const cookies = useCookies([COOKIE_NAME])

const consent = computed<CookieConsentValue | null>(() => {
  const value = cookies.get(COOKIE_NAME)
  return value === 'accepted' || value === 'rejected' ? value : null
})

const isVisible = computed(
  () => !!featureFlag.cookiePolicy?.enabled && consent.value === null
)

function setConsent(value: CookieConsentValue) {
  cookies.set(COOKIE_NAME, value, {
    path: '/',
    sameSite: 'lax',
    expires: new Date(Date.now() + COOKIE_EXPIRATION_TIME),
  })
}

function accept() {
  setConsent('accepted')
}

function reject() {
  setConsent('rejected')
}

function openSettings() {
  settingsOpen.value = true
}

// function goToCookiePolicy() {
//   settingsOpen.value = false
//   router.push('/cookie-policy')
// }
</script>
